const AdminDashboard: React.FC = () => {
  return <div>Conteúdo do Dashboard</div>;
};

export default AdminDashboard;
